import { createAction, props } from '@ngrx/store';

import { EventSelectorOptions, IEvent, IEventOrderDateRange, IEventPeriodItem } from '@shared/types';

export const EVENT_SELECTION_SUCCESS = 'EVENT_SELECTION_SUCCESS';
export const SHOW_EVENT_SELECTOR = 'SHOW_EVENT_SELECTOR';
export const SHOW_EVENT_SELECTOR_FINISH = 'SHOW_EVENT_SELECTOR_FINISH';

export const EVENT_SELECTION_FROM_PORTAL = 'EVENT_SELECTION_FROM_PORTAL';

export const UPDATE_EVENT_SELECTION = 'UPDATE_EVENT_SELECTION';
export const UPDATE_EVENT_SELECTION_SUCCESS = 'UPDATE_EVENT_SELECTION_SUCCESS';
export const UPDATE_EVENT_SELECTION_FAILURE = 'UPDATE_EVENT_SELECTION_FAILURE';

export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';

export const RESET_EVENTS = 'RESET_EVENTS';

export const event_selection_from_portal = createAction(`${EVENT_SELECTION_FROM_PORTAL}`, props<{ payload: any }>());

export const get_events = createAction(
    `${GET_EVENTS}`,
    props<{ companyId: string; all_as_default: boolean; dataFilter: string; defaultSort: string }>(),
);
export const get_events_success = createAction(
    `${GET_EVENTS_SUCCESS}`,
    props<{
        events: Array<IEvent>;
        eventsOrderDateRange: Record<string, IEventOrderDateRange>;
        originalEventPeriodData?: IEventPeriodItem[];
    }>(),
);
export const get_events_failure = createAction(`${GET_EVENTS_FAILURE}`);

export const show_event_selector = createAction(
    `${SHOW_EVENT_SELECTOR}`,
    props<{
        options: EventSelectorOptions;
        msgOptions: {
            messageId: string;
        };
    }>(),
);
export const show_event_selector_finish = createAction(SHOW_EVENT_SELECTOR_FINISH);
export const reset_events = createAction(`[EVENT_REDUCER] ${RESET_EVENTS}`);
export const update_event_selection = createAction(
    `[EVENT_REDUCER] ${UPDATE_EVENT_SELECTION}`,
    props<{ events: Array<IEvent>; isMultiple: boolean; reportId: string }>(),
);
export const update_event_selection_success = createAction(
    `[EVENT_REDUCER] ${UPDATE_EVENT_SELECTION_SUCCESS}`,
    props<{ events: Array<IEvent>; isMultiple: boolean; reportId: string }>(),
);
export const update_event_selection_failure = createAction(`[EVENT_REDUCER] ${UPDATE_EVENT_SELECTION_FAILURE}`);
